import {useCallback, useState} from 'react';
import {NotificationSnackbar} from "./NotificationSnackbar";

const useNotificationSnackbar = (errorParser) => {
    const [notification, setNotification] = useState();

    const createNotification = useCallback(
        (severity, title, messages) => {
            setNotification({
                severity,
                title,
                messages
            });
        },
        []
    );

    const showError = useCallback(
        e => {
            if (errorParser) {
                const {title, messages} = errorParser(e);
                createNotification("error", title, messages);
            } else {
                const title = "ERRORE";
                let messages = [];
                try {
                    messages = [e.toString()];
                } catch (e) {
                    console.error("Error does not have the method toString()");
                }

                createNotification("error", title, messages);
            }
        },
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const showSuccess = useCallback(
        (title, message) => {
            createNotification(
                "success",
                title || "Operazione eseguita con successo",
                typeof message === "string" ? [message] : []
            );
        },
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const handleClose = useCallback(
        () => {
            setNotification();
        },
        []);

    return {
        notification,
        handleClose,
        showError,
        showSuccess
    }
};

export {useNotificationSnackbar, NotificationSnackbar}